export const sortOptions = [
  { label: 'mostRecent', value: '-createdAt', text: 'recent' },
  { label: 'oldestFirst', value: 'createdAt', text: 'oldest' },
  { label: 'mostProgressed', value: '-progressedStep', text: 'progress' },
];

export const sellingSortOptions = [
  {
    label: 'leastWatchlistedFirst',
    value: 'watchlistCounter',
    text: 'watchlist',
  },
  {
    label: 'mostWatchlistedFirst',
    value: '-watchlistCounter',
    text: 'watchlist',
  },
];
